import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入flexible适配方案
import './plugins/flexible'

// 引入elementjs插件
import './plugins/element.js'

// 导入全局样式表
import './assets/css/global.css'

// 导入字体图标
import './assets/fonts/iconfont.css'

import TreeTable from 'vue-table-with-tree-grid'
Vue.component('tree-table', TreeTable)

import http from '@/network/http'
// 引入图表
import VCharts from 'v-charts'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })

// 引入事件总线
import eventbus from '@/utils/eventbus'
Vue.prototype.$eventbus = eventbus

Vue.use(VCharts)
import * as echarts from 'echarts'
// 制作地图
Vue.prototype.$echarts = echarts
import world from 'echarts/map/json/world.json'
echarts.registerMap('world', world)
import '@/utils/install'
Vue.prototype.$post = http.post
Vue.prototype.$get = http.get
Vue.prototype.$getParams = http.getParams
Vue.prototype.$delete = http.delete
Vue.prototype.$export = http.export
Vue.prototype.$downloadPdf = http.downloadPdf
Vue.prototype.$postList = http.postList
Vue.prototype.$postFile = http.postFile
Vue.prototype.$getBaseUrl = http.getBaseUrl

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  NProgress.done()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
